import { ethers } from 'ethers';
import { ACTIVE_NETWORK } from './networks';

// One shared read-only provider for the whole app (user side + admin panel).
// StaticJsonRpcProvider skips the eth_chainId request ethers' JsonRpcProvider sends
// before every batch of calls - measured ~3-5x faster on BSC dataseed.
export const readProvider = new ethers.providers.StaticJsonRpcProvider(ACTIVE_NETWORK.rpcUrl, {
  chainId: ACTIVE_NETWORK.chainId,
  name: ACTIVE_NETWORK.name
});
